import request from '../utils/request'


/**
 * 指南共识列表
 * @param {
 *    page,
 *    per_page,
 *    keyword,
 *    category_id,
 *    uid       
 * }
 * @returns
 */
export function getGuideLineList(params) {
    return request.get(`/document/index`, {params})
}

/**
 * 获取指南共识栏目
 * @param {*} params
 */
export function getGuideLineTabs() {
    return request.get(`/document/categories`, {})
}

/**
 * 获取指南共识详情
 * @param {*} params
 */
export function getGuideLineDetail(id) {
    return request.get(`/document/show/${id}`, {})
}